var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketStitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 239,
    viewBox: "0 0 5 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 239,
    width: 36,
    height: 5,
    rx: 2.5,
    transform: "rotate(-90 0 239)",
    fill: "#E6E7E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 198,
    width: 36,
    height: 5,
    rx: 2.5,
    transform: "rotate(-90 0 198)",
    fill: "#E6E7E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 158,
    width: 36,
    height: 5,
    rx: 2.5,
    transform: "rotate(-90 0 158)",
    fill: "#E6E7E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 117,
    width: 36,
    height: 5,
    rx: 2.5,
    transform: "rotate(-90 0 117)",
    fill: "#E6E7E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 77,
    width: 36,
    height: 5,
    rx: 2.5,
    transform: "rotate(-90 0 77)",
    fill: "#E6E7E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 36,
    height: 5,
    rx: 2.5,
    transform: "rotate(-90 0 36)",
    fill: "#E6E7E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketStitch);
export default __webpack_public_path__ + "static/media/TicketStitch.1654b3733dd857bc284f6c8e01769b26.svg";
export { ForwardRef as ReactComponent };